import type { ThemeWithoutTokens } from '../theme.types';

export const cellTextSubTokens = (theme: ThemeWithoutTokens) =>
  ({
    cellTextSubSubColor: theme.palette.grey400,
    cellTextSubSubFontWeight: theme.typography.fontWeight.normal,
  }) as const;
